import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  recordedQuestionsData: [],
  totalrecordedQuestions: 0,
  isOpenModal: false,
}

export const recordedQuestionsSlice = createSlice({
  name: "recordedQuestions",
  initialState,
  reducers: {
    setrecordedQuestionsData(state, { payload }) {
      state.recordedQuestionsData = payload.result
      state.totalrecordedQuestions = payload.count
    },
    updaterecordedQuestionsData(state, { payload }) {
      const objIndex = state.recordedQuestionsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.recordedQuestionsData[objIndex] = payload
      }
    },
    deleterecordedQuestionsData(state, { payload }) {
      const objIndex = state.recordedQuestionsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.recordedQuestionsData.splice(objIndex, 1)
      }
    },
    pushrecordedQuestionsData(state, { payload }) {
      state.recordedQuestionsData.push(payload)
       state.totalrecordedQuestions += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setrecordedQuestionsData, updaterecordedQuestionsData, deleterecordedQuestionsData, pushrecordedQuestionsData, isOpenModal,
  ModalToggle } = recordedQuestionsSlice.actions;

export default recordedQuestionsSlice.reducer;

export function getrecordedQuestions(limit, offset, id) {
  return async function getrecordedQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getrecordedQuestions(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setrecordedQuestionsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addrecordedQuestions(payload) {
  return async function addrecordedQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addrecordedQuestions(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushrecordedQuestionsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updaterecordedQuestions(id, data) {
  return async function updaterecordedQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updaterecordedQuestions(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updaterecordedQuestionsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteRecordedQuestions(id) {
  return async function deleteRecordedQuestionsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteRecordedQuestions(id).then(
        (response) => {
          dispatch(deleterecordedQuestionsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



